"use client"

import useSmoothScroll from "@/hooks/useSmoothScroll"
import React, { useEffect } from "react"

export function SmoothScrollProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const scrollToElement = useSmoothScroll()

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      const link = target.closest('a[href^="#"]')

      if (link) {
        e.preventDefault()
        const href = link.getAttribute("href")
        if (href) {
          const elementId = href.slice(1)
          scrollToElement(elementId, { offset: 120 })
        }
      }
    }

    document.addEventListener("click", handleClick)
    return () => {
      document.removeEventListener("click", handleClick)
    }
  }, [scrollToElement])

  return <>{children}</>
}
